import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "holiday-form" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = ["for"]
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = { class: "buttons" }

import { getKey } from "@/common/util";
import { HolidayItem } from "@/services/entities/HolidayItem";
import { useSettingsStore } from "@/stores/setting";
import { formatMXDate } from "@/common/date";


export default /*@__PURE__*/_defineComponent({
  __name: 'HolidayForm',
  props: {
    value: { Type: [] as HolidayItem[], default: [] as HolidayItem[] },
},
  setup(__props) {

const settingStore = useSettingsStore();

const props = __props;

function checkDate(item: Date) {
    item = new Date(item.toDateString());
    if (settingStore.getHolidays.some(a => new Date(a.date) == item)) {

    }
}

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: _unref(getKey)('holiday', index)
        }, [
          _createElementVNode("div", null, [
            _cache[0] || (_cache[0] = _createElementVNode("label", null, "Day of holiday", -1)),
            _createVNode(_component_VueDatePicker, {
              teleport: true,
              modelValue: item.date,
              "onUpdate:modelValue": [($event: any) => ((item.date) = $event), checkDate],
              "enable-time-picker": false,
              clearable: false,
              format: _unref(formatMXDate)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "format"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", {
              for: _unref(getKey)('holiday', index) + '_n'
            }, "Name", 8, _hoisted_2),
            _withDirectives((_openBlock(), _createElementBlock("input", {
              type: "string",
              key: _unref(getKey)('holiday', index) + '_n',
              "onUpdate:modelValue": ($event: any) => ((item.name) = $event)
            }, null, 8, _hoisted_3)), [
              [_vModelText, item.name]
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", {
              for: _unref(getKey)('holiday', index) + '_n'
            }, "Description", 8, _hoisted_4),
            _withDirectives((_openBlock(), _createElementBlock("input", {
              type: "string",
              key: _unref(getKey)('holiday', index) + '_n',
              "onUpdate:modelValue": ($event: any) => ((item.description) = $event)
            }, null, 8, _hoisted_5)), [
              [_vModelText, item.description]
            ])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "buttons")
    ])
  ], 64))
}
}

})